module.exports = __webpack_public_path__ + "static/media/digitalmarketing.36cd5450.png";